/*!
 * Copyright (c) 2024 Gateway Forge LLC.
 * All rights reserved.
 *
 * This software and its source code are proprietary and confidential to Gateway Forge LLC.
 * Unauthorized copying, distribution, or modification is prohibited.
 */

import React from 'react'
import { Column } from '../../layout/components/dom'

function NoPage() {
  return <Column style={{alignItems: 'center', margin: 100}}>
    The page you are trying to access does not exist.
  </Column>
}

export default NoPage